import React from 'react';
import { VsPageLayout } from '../components/VsPageLayout';
export function VsLindy() {
  return <VsPageLayout competitorName="Lindy.ai" competitorDescription="Lindy.ai is an AI assistant platform focused on individual task automation." seoTitle="MindStream.ing vs Lindy.ai — Full Comparison" comparisonRows={[{
    feature: 'Full business automation',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Voice AI (call and talk)',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Self-managing CRM',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Project management',
    mistr: '✅',
    competitor: 'Limited'
  }, {
    feature: 'PPC campaign management',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Self-building website',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Dedicated phone lines',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Multilingual (any language)',
    mistr: '✅',
    competitor: 'Limited'
  }, {
    feature: 'White-label available',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Named AI persona (MISTR + last name)',
    mistr: '✅',
    competitor: '❌'
  }]} whyMistrWins={[{
    title: 'Full Business OS',
    desc: 'Not just task automation. MR runs your entire business end-to-end.'
  }, {
    title: 'Voice-First',
    desc: 'Zero learning curve. Just talk to MR like a real employee.'
  }, {
    title: 'Named Persona',
    desc: 'Trained on YOUR business, YOUR voice, and named after you.'
  }, {
    title: 'One Price',
    desc: 'Everything included for one flat monthly rate.'
  }]} cantDoList={['Run your entire business end-to-end', 'Answer your phone 24/7', 'Manage your CRM automatically', 'Build and maintain your website', 'Run your PPC campaigns']} priceComparison={{
    competitorPrice: 'Starts at $49/mo',
    competitorDesc: 'for basic task automation',
    mistrPrice: '$997/mo',
    mistrDesc: 'for complete business automation',
    note: 'The comparison: Lindy automates tasks, MR runs your business.'
  }} data-id="element-2898" />;
}